import React from 'react';
import { Avatar } from "@mui/material";
import {
  LiveChatHeader,
  LiveChatHeaderIcon,
  WelcomeTxtBox,
  HelloTxt,
  WelcomeTxt,
  LiveChatBody,
  LiveChatOption,
  LiveChatOptionMid,
  LiveChatOptionTl,
  LiveChatOptionDesc,
  LiveChatOptionArrow,
  LiveChatOptionAvatar,
} from "@/pages/Customer/styles/Dashboard.styles";

import ChartIcon from "@/assets/images/live-chat-icon.svg"
import BotIcon from "@/assets/images/chat-bot-icon.svg";
import LongRightIcon from "@/assets/images/long-arrow-right.svg";


interface ChatOptionsProps {
  onSelectMode: (mode: 'ai' | 'agent') => void;
  customerName?: string;
  agent?: boolean;
  // companyName?: string;
  // customerAvatar?: string;
}

const ChatOptions: React.FC<ChatOptionsProps> = ({ onSelectMode, customerName }) => {
  // Get time-based greeting
  const getTimeBasedGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 17) return 'Good afternoon';
    return 'Good evening';
  };

  // Create personalized greeting
  const greeting = customerName
    ? `${getTimeBasedGreeting()} ${customerName}!`
    : 'Hello!';

  // Create personalized description
  const description = customerName
    ? `Hi ${customerName}! Get instant assistance with your questions.`
    : 'Get instant assistance with your questions.';

  /* 
  // 🚀 FUTURE ENHANCEMENTS:
  // 1. Create welcome message with company name
  // const welcomeMessage = companyName
  //   ? `Welcome to ${companyName} Chat`
  //   : 'Welcome To Chat';

  // 2. Customer Avatar:
  // const userAvatar = customerAvatar || '/images/default-user.svg';
  */

  return (
    <>
      <LiveChatHeader>
        <LiveChatHeaderIcon>
          <img src={ChartIcon} alt="" />
        </LiveChatHeaderIcon>
        <WelcomeTxtBox>
          <HelloTxt>{greeting}</HelloTxt>
          <WelcomeTxt>
            Welcome To <span>Chat <span className=""></span></span>
          </WelcomeTxt>
        </WelcomeTxtBox>
      </LiveChatHeader>
      <LiveChatBody>
        <LiveChatOption onClick={() => onSelectMode('ai')}>
          <LiveChatOptionAvatar>
            <Avatar
              alt={"Chat"}
              src={BotIcon}
              sx={{
                width: 52,
                height: 52,
                backgroundColor: '#D4FFD9',
                color: '#202935',
                '& img': {
                  width: 26,
                  height: 'auto'
                }
              }}
            />
          </LiveChatOptionAvatar>
          <LiveChatOptionMid>
            <LiveChatOptionTl variant="h4">Start Chatting</LiveChatOptionTl>
            <LiveChatOptionDesc>{description}</LiveChatOptionDesc>
          </LiveChatOptionMid>
          <LiveChatOptionArrow>
            <img src={LongRightIcon} alt="" />
          </LiveChatOptionArrow>
        </LiveChatOption>
      </LiveChatBody>
    </>
  );
};

export default ChatOptions; 